import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";

@Injectable({
  providedIn: "root",
})
export class ChatService {
  constructor(private angularFireStore: AngularFirestore) {}

  createConversation(chat) {
    return this.angularFireStore
      .collection(`chats/${chat.chatId}/messages`)
      .doc(`${chat.timestamp}`)
      .set(chat);
  }

  getConversation(id) {
    return this.angularFireStore
      .collection(`/chats/${id}/messages`)
      .valueChanges();
  }
}
